/* tslint:disable */
/* eslint-disable */
/**
 * CheckFlow
 * CheckFlow
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActiveAreaManager
 */
export interface ActiveAreaManager {
    /**
     * 
     * @type {number}
     * @memberof ActiveAreaManager
     */
    areaId?: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveAreaManager
     */
    employeeId?: number;
    /**
     * 
     * @type {string}
     * @memberof ActiveAreaManager
     */
    emailAddress?: string | null;
}

/**
 * Check if a given object implements the ActiveAreaManager interface.
 */
export function instanceOfActiveAreaManager(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ActiveAreaManagerFromJSON(json: any): ActiveAreaManager {
    return ActiveAreaManagerFromJSONTyped(json, false);
}

export function ActiveAreaManagerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveAreaManager {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'areaId': !exists(json, 'areaId') ? undefined : json['areaId'],
        'employeeId': !exists(json, 'employeeId') ? undefined : json['employeeId'],
        'emailAddress': !exists(json, 'emailAddress') ? undefined : json['emailAddress'],
    };
}

export function ActiveAreaManagerToJSON(value?: ActiveAreaManager | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'areaId': value.areaId,
        'employeeId': value.employeeId,
        'emailAddress': value.emailAddress,
    };
}

